module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/howto-step2-1d1cd96bfdc3bf87757ad1c4fb815ba6.svg";